import { InclusiveExclusiveModelComparator } from './comparators/inclusive-exclusive-model-comparator';
import {
  InclusiveExclusiveFilterModel,
  IFilterComparator,
  ConfigureOptionsParams,
  FilterOptions
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { convertToStringArray } from '../filter-utils';
import { SeriesFilterHandler } from './base/series-filter-handler';

export class PurposeFilterHandler extends SeriesFilterHandler {
  private comparator: IFilterComparator<InclusiveExclusiveFilterModel>;

  get name(): string {
    return CalendarGridColumnName.Purpose;
  }

  get isInclusiveExclusive(): boolean {
    return true;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    params.setFilterService.purpose = params.filterOptions.purpose;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return convertToStringArray(filterOptions.purpose);
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options
  ): IFilterComparator<InclusiveExclusiveFilterModel> {
    if (!this.comparator) {
      this.comparator = new InclusiveExclusiveModelComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }
}
